import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { deleteUser } from 'firebase/auth';
import userService from '../../services/userService';
import './Sidebar.css';

const Sidebar = ({ isOpen, onClose, onShowTerms, onShowHowTo }) => {
  const { currentUser, logout, userRole } = useAuth();

  const handleSignOut = async () => {
    try {
      if (logout) {
        await logout();
      } else {
        console.log('Demo logout - no auth context');
        alert('ログアウトしました（デモ）');
      }
      onClose();
    } catch (error) {
      console.error('サインアウトエラー:', error);
      alert('サインアウトに失敗しました。');
    }
  };

  const handleWithdrawal = async () => {
    const confirmed = window.confirm(
      '本当に退会しますか？この操作は取り消せません。'
    );
    
    if (!confirmed) return;

    try {
      if (!currentUser) {
        console.log('Demo withdrawal - no current user');
        alert('退会しました（デモ）');
        onClose();
        return;
      }
      
      const uid = currentUser.uid;
      console.log('Starting withdrawal process for user:', uid, 'Role:', userRole);
      
      // Use userService to delete user with all related data
      console.log('Deleting user data from Firestore...');
      await userService.deleteUserWithRelatedData(uid);
      console.log('Firestore data deletion completed');

      // Delete the Firebase Auth user
      console.log('Deleting Firebase Auth user...');
      await deleteUser(currentUser);
      console.log('Firebase Auth user deletion completed');
      
      onClose();
      alert('退会が完了しました。');
    } catch (error) {
      console.error('退会エラー:', error);
      console.error('Error message:', error.message);
      console.error('Error code:', error.code);
      alert("退会処理に失敗しました。時間をおいて再度お試しください。解決しない場合は管理者にお問い合わせください。");
    }
  };

  const handleContactClick = () => {
    window.open('https://forms.gle/gFTcqhmFRXoody6r7', '_blank');
    onClose();
  };

  const handleTermsClick = () => {
    onShowTerms();
    onClose();
  };

  const handleHowToClick = () => {
    onShowHowTo();
    onClose();
  };

  return (
    <>
      {/* Overlay */}
      <div 
        className={`sidebar-overlay ${isOpen ? 'active' : ''}`}
        onClick={onClose}
      />
      
      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h3>メニュー</h3>
          <button className="close-button" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <div className="sidebar-content">
          <nav className="sidebar-nav">
            <button 
              className="sidebar-item"
              onClick={handleHowToClick}
            >
              <i className="fas fa-info-circle"></i>
              <span>利用方法</span>
            </button>
            
            <button 
              className="sidebar-item"
              onClick={handleTermsClick}
            >
              <i className="fas fa-file-contract"></i>
              <span>利用規約</span>
            </button>
            
            <button 
              className="sidebar-item"
              onClick={handleContactClick}
            >
              <i className="fas fa-question-circle"></i>
              <span>問い合わせ</span>
            </button>
            
            <button 
              className="sidebar-item"
              onClick={handleSignOut}
            >
              <i className="fas fa-sign-out-alt"></i>
              <span>ログアウト</span>
            </button>
            
            <button 
              className="sidebar-item withdrawal"
              onClick={handleWithdrawal}
            >
              <i className="fas fa-user-times"></i>
              <span>退会</span>
            </button>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar;